import { $dayjs, setDayjsLocale } from '~/utils/dayjs'

export const dateRange = ({ i18n, startDate, endDate }) => {
  if (!startDate || !endDate) return ''
  setDayjsLocale(i18n.locale)
  const startMonth = $dayjs(startDate).month()
  const endMonth = $dayjs(endDate).month()
  const sameMonth = startMonth === endMonth
  let startFormat = sameMonth ? 'DD' : 'DD MMM'
  let endFormat = 'DD MMM'

  if (i18n.locale.value === 'en') {
    startFormat = 'MMM DD'
    endFormat = sameMonth ? 'DD' : 'MMM DD'
  }

  return i18n.t('house.dateRange', {
    start: $dayjs(startDate).format(startFormat),
    end: $dayjs(endDate).format(endFormat),
    year: $dayjs(endDate).format('YYYY'),
  })
}
